var _g, _line, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodToBottomArcFa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "217px",
    height: "232px",
    viewBox: "0 0 578.9 619",
    enableBackground: "new 0 0 578.9 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 71.9,
    y1: 100.6,
    x2: 71.9,
    y2: 515
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "62.9,103.2 71.9,87.7 80.9,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "62.9,512.4 71.9,528 80.9,512.4  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 607.4,
    x2: 480,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 79.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 415.3,
    y: 76.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 76.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.8,
    y: 66,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2,
    y: 66,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 460.5,107.5 470,98 10.3,98 19.2,107.5 459.2,107.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 65.8,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M505.1,607.5c-0.8,0-1.6-0.2-2.3-0.6c0,0.5,0,1,0,1.5c-0.1,0.5-0.2,1-0.3,1.5c-0.2,0.6-0.5,1.1-0.8,1.6 c-0.4,0.5-0.8,0.9-1.3,1.2c-0.6,0.4-1.2,0.7-2,0.9s-1.6,0.3-2.5,0.4h-0.4c-0.8,0-1.6-0.1-2.3-0.4c-0.7-0.2-1.3-0.6-1.8-1.1 c-0.5-0.4-0.9-1-1.2-1.6c-0.3-0.6-0.5-1.2-0.6-2c-0.1-0.4-0.1-0.8-0.1-1.2c0-0.4,0-0.8,0.1-1.1c0-0.4,0.1-0.7,0.2-1 s0.1-0.6,0.2-0.9c0.2-0.7,0.4-1.2,0.6-1.7c0.2-0.5,0.4-0.8,0.6-1l1.5,1.1c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.2,0.5-0.3,0.8 c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.2,0.7-0.3,1.1s-0.1,0.8-0.1,1.1c0,0.4,0,0.8,0.1,1.1c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.2,0.2,0.5,0.3,0.7s0.3,0.5,0.5,0.7c0.2,0.2,0.4,0.5,0.7,0.6c0.3,0.2,0.6,0.3,1,0.5c0.4,0.1,0.9,0.2,1.4,0.2h0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c1.3-0.1,2.4-0.3,3.3-0.8c0.8-0.5,1.4-1.2,1.7-2c0.2-0.6,0.3-1.1,0.3-1.7c0-0.5,0-1.1-0.1-1.6 c-0.1-0.5-0.2-1-0.3-1.4s-0.3-0.8-0.4-1.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.1l1.6-1c0,0,0.1,0.2,0.2,0.4s0.3,0.5,0.5,0.9c0.4,0.7,0.7,1.2,1,1.6c0.3,0.4,0.6,0.7,0.9,0.9 c0.3,0.2,0.5,0.3,0.8,0.4c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7 C505.6,607.4,505.4,607.5,505.1,607.5z M497.7,602l-1.6,1.6l-1.6-1.6l1.6-1.6L497.7,602z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M504.2,606.5c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3h0.7c0.5,0,1,0,1.5-0.1 c0.5-0.1,0.9-0.2,1.3-0.4s0.7-0.4,0.9-0.7s0.3-0.7,0.3-1.1c0-0.4,0-0.7-0.1-1.1s-0.1-0.8-0.3-1.3l1.8-0.5c0.1,0.2,0.1,0.5,0.2,0.7 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0.1,0.5,0.1,0.8c0,0.3,0,0.5,0.1,0.8c0,0.2,0,0.5,0.1,0.7c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.1,0,0.3-0.1,0.4 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1-0.9 c-0.2,0.2-0.5,0.4-0.9,0.6s-0.8,0.3-1.2,0.4c-0.4,0.1-0.9,0.2-1.4,0.2c-0.5,0-0.9,0.1-1.4,0.1h-0.7c-0.3,0-0.5-0.1-0.7-0.3 C504.2,607,504.2,606.8,504.2,606.5z M508.1,611.1l-1.5,1.5l-1.6-1.6l1.5-1.6L508.1,611.1z M512.1,611.1l-1.5,1.6l-1.6-1.6 l1.5-1.5L512.1,611.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M512.5,606.5c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3h0c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.7-0.4,1-0.7 c0.3-0.3,0.5-0.6,0.7-1s0.4-0.8,0.6-1.2c0.2-0.3,0.3-0.7,0.5-1c0.2-0.3,0.4-0.6,0.6-0.9c0.6-0.7,1.3-1.1,2.1-1.1 c1,0,1.8,0.4,2.4,1.2c0.5,0.6,0.8,1.4,0.9,2.3c0.1,0.4,0.1,0.9,0,1.3s-0.1,0.8-0.3,1.2c-0.2,0.5-0.4,0.8-0.7,1.1 c-0.3,0.3-0.7,0.5-1.1,0.6c-0.7,0.2-1.5,0.1-2.4-0.3c-0.6-0.2-1.3-0.6-1.9-1.1c0,0-0.1,0.1-0.1,0.1c-1,1-2.2,1.5-3.6,1.5h0 c-0.3,0-0.5-0.1-0.7-0.3C512.5,607,512.5,606.8,512.5,606.5z M518.2,604.3c0.6,0.4,1.1,0.7,1.6,0.9c0.5,0.2,0.9,0.2,1.2,0.2 c0.1,0,0.2-0.1,0.3-0.2s0.2-0.3,0.3-0.5s0.1-0.4,0.2-0.7c0-0.2,0-0.5,0-0.8c0,0,0-0.1,0-0.2s-0.1-0.2-0.1-0.4s-0.1-0.3-0.2-0.4 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.2-0.2,0.3-0.4,0.6c-0.1,0.2-0.3,0.5-0.4,0.8L518.2,604.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M529.3,601.2c0.2,0.6,0.3,1.2,0.5,1.8c0.1,0.2,0.1,0.5,0.2,0.8c0.1,0.3,0.1,0.5,0.2,0.8 c0.1,0.3,0.1,0.5,0.2,0.8c0,0.3,0.1,0.5,0.1,0.7c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.6-0.1,1.1-0.2,1.6 c-0.2,0.5-0.4,1-0.7,1.5c-0.3,0.5-0.6,0.9-1,1.4c-0.4,0.4-0.8,0.9-1.3,1.2s-1,0.7-1.5,1.1c-0.5,0.3-1,0.6-1.6,0.9l-0.8-1.7 c0.7-0.3,1.3-0.7,2-1.2c0.6-0.4,1.2-0.9,1.7-1.4s0.9-1.1,1.2-1.6c0.3-0.6,0.4-1.2,0.4-1.8c0,0,0-0.1,0-0.2s0-0.1,0-0.2v0 c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.1-0.5-0.2-0.7c-0.2-0.5-0.3-1.1-0.5-1.6 L529.3,601.2z M529.7,597.3l-1.6,1.6l-1.6-1.6l1.6-1.6L529.7,597.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M556.4,605.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0.4,0.1,0.8,0.1,1.2,0.2c0.4,0,0.8,0.1,1.2,0.1 c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2 s-0.2,0.1-0.4,0.1c-0.8,0-1.6-0.1-2.4-0.2c-0.8-0.1-1.5-0.3-2.1-0.5c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1 c-0.3,0.1-0.7,0.2-1.1,0.3c-0.4,0.1-0.9,0.2-1.4,0.2s-1.1,0.1-1.6,0.1c-0.6,0-1.1,0-1.7,0c-2,0-3.6-0.2-4.9-0.7 c-1.3-0.5-2.2-1.2-2.8-2.2c-0.3-0.4-0.4-0.9-0.5-1.3c-0.1-0.4-0.1-0.9-0.1-1.3c0-0.4,0.1-0.8,0.1-1.2c0.1-0.4,0.2-0.7,0.3-1 c0.1-0.3,0.2-0.5,0.3-0.7c0.1-0.2,0.1-0.3,0.1-0.3l1.7,0.9c0,0,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.4-0.2,0.7 s-0.1,0.5-0.1,0.8s0,0.6,0,0.9c0,0.3,0.2,0.6,0.3,0.9c0.2,0.3,0.4,0.6,0.7,0.8c0.3,0.2,0.7,0.4,1.1,0.6c0.4,0.2,1,0.3,1.6,0.4 c0.6,0.1,1.3,0.1,2.1,0.2c0.6,0,1.1,0,1.6,0c0.5,0,0.9,0,1.2-0.1c0.4,0,0.7-0.1,1-0.1s0.6-0.1,0.8-0.1c-0.9-0.7-1.3-1.6-1.3-2.5 c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.4-1,0.8-1.4c0.3-0.4,0.7-0.8,1.2-1c0.4-0.2,0.9-0.4,1.4-0.4c0.4,0,0.8,0.1,1.2,0.2 s0.7,0.4,1,0.7c0.1,0.1,0.2,0.3,0.4,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.3,0.1,0.7,0.1,1 C557.2,603.4,556.9,604.4,556.4,605.1z M554,604.7c0.3-0.2,0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.6 s0-0.4,0-0.7c0-0.5-0.1-0.8-0.2-1.1c-0.1-0.3-0.2-0.5-0.4-0.6c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.3,0-0.3,0 c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.3,0.1,0.6,0.4,0.9 c0.3,0.3,0.7,0.6,1.2,0.8L554,604.7z M555.5,594.7l-1.6,1.6l-1.6-1.6l1.6-1.6L555.5,594.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M557.6,606.5c0-0.3,0.1-0.5,0.3-0.7s0.4-0.3,0.7-0.3h1c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.2-0.1 c0.4-0.1,0.7-0.2,1-0.3c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.7,0.4-1s0-0.8-0.1-1.2c-0.1-0.3-0.2-0.6-0.5-1 c-0.3-0.4-0.6-0.8-1-1.3c-0.4-0.5-0.9-0.9-1.4-1.4c-0.5-0.5-1-0.9-1.5-1.4l0.2-2l7.9-3.4l0.7,1.7l-6.8,2.9c0.3,0.3,0.7,0.6,1,0.9 c0.4,0.3,0.7,0.7,1.1,1.1c0.5,0.5,0.9,1,1.2,1.5c0.3,0.5,0.6,1,0.7,1.4c0.2,0.4,0.3,0.9,0.3,1.2c0.1,0.4,0.1,0.8,0,1.1 c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.2,0.6-0.3,0.8c-0.6,1-1.5,1.6-2.9,1.9c-0.2,0-0.5,0.1-0.8,0.1h-3.1c-0.3,0-0.6-0.1-0.7-0.3 C557.6,607,557.6,606.8,557.6,606.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodToBottomArcFa);
export default __webpack_public_path__ + "static/media/RodToBottom_arc_fa.6d792209ec18e22c1a997d52b4f1a4d5.svg";
export { ForwardRef as ReactComponent };